import { useContext, useEffect, useRef, useState } from "react";
import { request } from "../../../../../request";
import { MainContext } from "../../../../../MainContext";
import Select from "react-select";
import Swal from "sweetalert2";
import MoneyInput from "../../../Inputs/MoneyInput";
import { motion } from "framer-motion";
import { icons } from "../../../../../icons";
import { useMediaQuery, useTheme } from "@mui/material";

const PlaceInputs = ({ label, values, setValues, noCustomers, noAccounts, disabled, prevInput, lastIndex, specifyRate, avgClose, selectedBound, specificCommingAvg, texts }) => {
    const [currencies, setCurrencies] = useState([]);
    const currencies_account = useRef(null);
    const [currencyInputsBlocked, setCurrencyInputsBlocked] = useState({
        currency: true,
        amount: false,
        avg: lastIndex,
    });
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [localSpecificCommingAvg, setLocalSpecificCommingAvg] = useState(0);

    const possibleCurrencies = useRef([]);

    useEffect(() => {
        setCurrencyInputsBlocked({
            ...currencyInputsBlocked,
            avg: lastIndex,
        });
    }, [lastIndex]);

    const { all_currencies, darkMode, accounts, customers } = useContext(MainContext);

    const updateCurrencies = () => {
        if (values.place.customerId) {
            setCurrencies(all_currencies);
            currencies_account.current = null;
        } else {
            setCurrencies(accounts.find((acc) => acc._id === values.place.accountId).currencies.map((curr) => curr.currency_name));
            currencies_account.current = values.place.accountId;
        }
    };

    useEffect(() => {
        console.log(values);
        if (values.place?.accountId) {
            if (currencies_account.current !== values.place.accountId) {
                updateCurrencies();
            }
            if (currencyInputsBlocked.currency) {
                setCurrencyInputsBlocked({
                    currency: false,
                    amount: false,
                    avg: lastIndex,
                });
            }
        }
        if (values.place.customerId && JSON.stringify(currencies) !== JSON.stringify(all_currencies)) {
            updateCurrencies();
        }
        if (values.place?.customerId) {
            console.log("1");
            if (!currencyInputsBlocked.currency || !currencyInputsBlocked.amount || !currencyInputsBlocked.avg) {
                console.log("2");
                setCurrencyInputsBlocked({
                    currency: true,
                    amount: true,
                    avg: true,
                });
            }
        }
        if (!values.place.customerId && !values.place.accountId) {
            console.log("3");
            if (!currencyInputsBlocked.currency || currencyInputsBlocked.amount) {
                console.log("4");
                setCurrencyInputsBlocked({
                    currency: true,
                    amount: false,
                    avg: lastIndex,
                });
            }
        }
        if (specificCommingAvg && values.commingAvg !== specificCommingAvg && !localSpecificCommingAvg) {
            setValues({ ...values, commingAvg: specificCommingAvg });
        }
    }, [values, lastIndex, localSpecificCommingAvg, specificCommingAvg]);

    useEffect(() => {
        if (noCustomers && values.place.customerId) {
            setValues({
                place: {
                    customerId: null,
                    accountId: null,
                },
                currency_name: "",
                amount: 0,
            });
        }
    }, [noCustomers]);

    const handleAccountInputChange = (e) => {
        const value = e;
        if (value?.type === "customerId") {
            setValues({
                currency_name: "",
                amount: 0,
                place: {
                    [value?.type]: value?.value._id,
                },
            });
        } else {
            setValues({
                ...values,
                currency_name: value?.value.currencies.length === 1 ? value?.value.currencies[0].currency_name : "",
                commingAvg: value?.value.currencies.length === 1 ? value?.value.currencies[0].avg : undefined,
                place: {
                    [value?.type]: value?.value._id,
                },
            });
            possibleCurrencies.current = value?.value.currencies;
        }
    };

    const transformOption = (option) => ({
        isDisabled: option._id === prevInput?.place.accountId && option.currencies.length === 1,
        value: option,
        label: option.name + (option.type && option.contact ? ` - ${option.type}` : ""),
        customLabel: (
            <div className="flex items-center">
                <img
                    style={{
                        width: "30px",
                        height: "30px",
                        marginRight: "10px",
                        backgroundColor: "black",
                        borderRadius: "50%",
                        padding: "5px",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                    }}
                    src={option.contact ? icons.user : icons[option.name.toUpperCase()] ? icons[option.name.toUpperCase()] : option.icon ? process.env.REACT_APP_BACK_SRC + "/api/" + "icons/" + option.icon : icons["CANCEL"]}
                />
                {option.name + (option.type && option.contact ? ` - ${option.type}` : "")}
            </div>
        ),
        type: option.contact ? "customerId" : "accountId",
    });

    const options = [...accounts, ...customers]
        .sort((a, b) => {
            const isAAccount = accounts.includes(a);
            const isBAccount = accounts.includes(b);

            if (isAAccount && !isBAccount) return -1;
            if (!isAAccount && isBAccount) return 1;

            return b.usability - a.usability;
        })
        .map(transformOption);

    const selectStyles = {
        container: (base) => ({
            ...base,
            width: window.innerWidth <= 650 ? "100%" : "200px",
        }),
        control: (base, state) => ({
            ...base,
            borderColor: state.isDisabled ? "#333" : "gray",
            borderRadius: "0.5rem",
            padding: "0.5rem",
            boxShadow: "none",
            marginRight: "15px",
            height: "56px",
            "&:hover": { borderColor: "blue" },
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? "#FEC901" : state.isFocused ? "lightgray" : "white",
            color: state.isSelected ? "black" : "black",
            "&:hover": {
                backgroundColor: "lightblue",
            },
        }),
        menu: (base) => ({
            ...base,
            marginTop: 0,
            borderRadius: "0.375rem",
        }),
        placeholder: (base) => ({
            ...base,
            color: "gray",
            fontSize: "0.875rem",
        }),
    };

    const getFullAmount = () => {
        if (values.place.accountId) {
            const fullAmount = accounts.find((acc) => acc._id === values.place.accountId).currencies.find((curr) => curr.currency_name === values.currency_name).value;
            setValues({
                ...values,
                amount: fullAmount,
            });
        }
    };

    const spring = {
        type: "spring",
        stiffness: 700,
        damping: 30,
    };

    return (
        <div className="lg:flex sm:relative items-center justify-between mb-5 px-15 place-inputs">
            <label className="text-lg ml-0 mb-[20px] font-bold leading-normal tracking-[0.015em] w-[80px]" htmlFor={`dropdown`} style={{ color: darkMode ? "white" : "black" }}>
                {label}
            </label>
            <div>
                <p style={{ color: "white", paddingLeft: "5px" }}>{texts.transactions.place}</p>
                <Select
                    options={options.filter((opt) => {
                        if (!!noAccounts && opt.type === "accountId") {
                            return false;
                        }
                        if (selectedBound && opt.type === "customerId") {
                            if (opt.value._id === selectedBound.value.customerId) {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (!!noCustomers && opt.type === "customerId") {
                            return false;
                        }
                        return true;
                    })}
                    isClearable
                    required
                    onChange={handleAccountInputChange}
                    styles={selectStyles}
                    isDisabled={!!disabled}
                    value={[...accounts, ...customers].filter((e) => e._id === values?.place?.customerId || e._id === values?.place?.accountId)?.map(transformOption)[0] || null}
                    getOptionLabel={(e) => e.customLabel} // Render custom JSX for the dropdown
                    filterOption={(option, input) => {
                        return option.data.label.toLowerCase().includes(input.toLowerCase()); // Filter based on plain text label
                    }}
                />
            </div>
            <div style={{ marginTop: isMobile ? "20px" : "" }}>
                <p style={{ color: "white", paddingLeft: "5px" }}>{texts.transactions.currency}</p>
                <select
                    className="appearance-none sm:w-[80px] w-[160px]  sm:mt-0  sm:mr-5 h-14 px-4 py-2 text-base text-gray-800 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all ease-in-out duration-150 hover:shadow-lg"
                    value={currencyInputsBlocked.currency ? "" : values.currency_name}
                    required
                    onChange={(e) =>
                        setValues({
                            ...values,
                            currency_name: e.target.value,
                            commingAvg: possibleCurrencies?.current?.find((c) => c.currency_name === e.target.value).avg,
                        })
                    }
                    disabled={currencyInputsBlocked.currency}
                    style={{ maxWidth: "260px" }}
                >
                    <option value="">...</option>
                    {currencies.map((value) => (
                        <option className="" disabled={prevInput?.currency_name === value && prevInput?.place.accountId === values.place.accountId} key={value} value={value}>
                            {value}
                        </option>
                    ))}
                </select>
            </div>

            <div style={{ position: "relative", width: window.innerWidth <= 650 ? "100%" : "170px" }}>
                <MoneyInput
                    type="text"
                    value={currencyInputsBlocked.amount ? 0 : values?.amount}
                    onChange={(value) => {
                        setValues({
                            ...values,
                            amount: value,
                        });
                    }}
                    placeholder={texts.transactions.amount}
                    uppervalue={texts.transactions.amount}
                    undervalue={accounts.find((account) => values.place.accountId === account._id)?.currencies.find((currency) => currency.currency_name === values.currency_name)}
                    required
                    disabled={currencyInputsBlocked.amount}
                    style={{
                        width: "100%",
                        paddingRight: "50px",
                    }}
                />

                {(label === "From" || label === "От") && values.place.accountId && (
                    <div onClick={getFullAmount} type="button" onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#FFD900")} onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#FEC901")} className="max-btn">
                        MAX
                    </div>
                )}
            </div>

            {window.innerWidth <= 650 ? (
                <></>
            ) : (
                <>
                    {!specifyRate && !avgClose && label === "From" && label === "От" && (
                        <div className="flex items-center sm:mt-0 justify-between">
                            <label htmlFor="name">
                                <MoneyInput
                                    type="text"
                                    uppervalue={"Avg"}
                                    value={currencyInputsBlocked.avg ? 0 : values.avg}
                                    onChange={(value) => {
                                        setValues({
                                            ...values,
                                            avg: value,
                                        });
                                    }}
                                    placeholder="Avg"
                                    disabled={currencyInputsBlocked.avg}
                                    style={{ width: window.innerWidth <= 650 ? "80%" : "100px" }}
                                />
                            </label>
                            <div
                                className={"switch " + (currencyInputsBlocked.avg ? "switch-disabled" : "")}
                                data-isOn={values?.isSellAvg}
                                onClick={() => !currencyInputsBlocked.avg && setValues({ ...values, isSellAvg: !values?.isSellAvg })}
                                style={{ marginTop: isMobile ? "50px" : "20px" }}
                            >
                                <motion.div className="handle" layout transition={spring} />
                            </div>
                        </div>
                    )}
                </>
            )}

            {specifyRate && (
                <label style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: window.innerWidth <= 650 ? "column" : "row" }} htmlFor="name">
                    <MoneyInput
                        type="text"
                        value={currencyInputsBlocked.amount ? 0 : localSpecificCommingAvg ? localSpecificCommingAvg : specificCommingAvg ? specificCommingAvg : values?.commingAvg}
                        onChange={(value) => {
                            console.log(value);
                            setValues({
                                ...values,
                                commingAvg: value,
                            });
                            setLocalSpecificCommingAvg(value);
                        }}
                        placeholder="Rate to add"
                        uppervalue={texts.transactions.rateToAdd}
                        required
                        disabled={currencyInputsBlocked.amount || (specificCommingAvg && !localSpecificCommingAvg)}
                        style={{ width: window.innerWidth <= 650 ? "100%" : "195px" }}
                    />
                    <button style={{ color: "white", padding: "5px", margin: "5px", marginTop: "30px", border: "1px solid white", height: "40px", borderRadius: "5px" }} type="button" onClick={() => setLocalSpecificCommingAvg(localSpecificCommingAvg ? 0 : specificCommingAvg)}>
                        {localSpecificCommingAvg ? "Reset" : "Edit"}
                    </button>
                </label>
            )}
        </div>
    );
};

export default PlaceInputs;
